import './CommonFeed.sass';

import React, { FC, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Header, Placeholder, ScrollView } from '$uikit';
import { feedActions, feedSelector } from '$store/feed';
import { InlineAuthForm, Loader, Post } from '$shared/components';
import { useTranslator } from '$hooks';
import { FeedItemType } from '$store/feed/interface';
import { AuthPopoverCommon } from '$core/AuthPopover/AuthPopover';
import { authSelector } from '$store/auth';
import { profileActions } from '$store/profile';
import { AuthPopoverState } from '$store/models';
import { setSubscriptionContentPriority } from '$utils/subscriptionAuthor';
import { ContentPriorityType } from '$store/main/interface';

export const CommonFeed: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const { isLogged } = useSelector(authSelector);
  const { commonLoadingStatus, common, commonLoadingMoreStatus, commonNextFrom } =
    useSelector(feedSelector);

  useEffect(() => {
    dispatch(feedActions.loadCommonFeed());
    setSubscriptionContentPriority(ContentPriorityType.ADULT);
  }, []);

  const handleRetry = useCallback(() => {
    dispatch(feedActions.loadCommonFeed());
  }, []);

  const handleLoadMore = useCallback(() => {
    dispatch(feedActions.commonFeedLoadMore());
  }, []);

  const signInHandle = useCallback(() => {
    dispatch(profileActions.setAuthPopoverState(AuthPopoverState.LOGIN));
  }, []);

  function renderContent() {
    if (commonLoadingStatus === 'loading' && !common.length) {
      return <Loader isWrapped />;
    }

    if (commonLoadingStatus === 'failed') {
      return (
        <Placeholder
          title={t('failed_title')}
          actions={
            <Button size="small" onClick={handleRetry}>
              {t('failed_button')}
            </Button>
          }
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    return (
      <ScrollView
        canLoadMore={commonLoadingMoreStatus === 'loaded' && !!commonNextFrom}
        isLoadingMore={commonLoadingMoreStatus === 'loading'}
        onLoadMore={handleLoadMore}
      >
        {!isLogged && (
          <div className="CommonFeed__auth_form">
            <div className="AuthPopover__avatars">
              <img
                className="AuthPopover__avatar aside left"
                src={require('../AuthPopover/assets/model1.png').default}
                alt="Avatar image"
              />
              <img
                className="AuthPopover__avatar"
                src={require('../AuthPopover/assets/model2.png').default}
                alt="Avatar image"
              />
              <img
                className="AuthPopover__avatar aside right"
                src={require('../AuthPopover/assets/model3.png').default}
                alt="Avatar image"
              />
            </div>
            <div className="CommonFeed__auth_form__title">Talk to PornHub models!</div>
            <div className="CommonFeed__auth_form__caption">
              Get a feed full of nudes from 200+ real girls with one subscription
            </div>
            <Button onClick={signInHandle}>Sign up for free</Button>
          </div>
        )}
        {common.map((item, i) => {
          let cont: any = null;
          if (item.type === FeedItemType.POST) {
            cont = (
              <Post
                key={item.id}
                postId={item.object as number}
                showFollowBtn={false}
                isRecommendations={false}
              />
            );
          }

          return (
            <div key={item.id}>
              {i > 0 && i % 5 === 0 && <InlineAuthForm />}
              {cont}
            </div>
          );
        })}
      </ScrollView>
    );
  }

  return (
    <>
      <Header>Ton.Place</Header>
      {renderContent()}
      <AuthPopoverCommon />
    </>
  );
};
